import { render, staticRenderFns } from "./HeadPanelDxCodeManagement.vue?vue&type=template&id=4bfbd2c4&scoped=true"
import script from "./HeadPanelDxCodeManagement.vue?vue&type=script&lang=js"
export * from "./HeadPanelDxCodeManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfbd2c4",
  null
  
)

export default component.exports